<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><a id="pg5">C<span class="small">ONTENTS</span></a></p><a id="pg5">
</a><p class="toc"><a id="pg5"></a><a href="#/introduction">Introduction</a></p>
<p class="toc3"><a href="#/chapter01">1. 1861: “We Are All Terribly Excited Here”</a></p>
<p class="toc2"><span href="#/chapter02" title="Link target outside of Sample">2. 1862: “This County Is a Perfect Den of Thieves and Tories”</span></p>
<p class="toc2"><span href="#/chapter03" title="Link target outside of Sample">3. 1863: “There Is No Doubt a Considerable Amount of Renegades Scattered Over the Mountains”</span></p>
<p class="toc2"><span href="#/chapter04" title="Link target outside of Sample">4. 1864: “Time Will Suffice to Tell You of All the Horrors to Which They Are Exposed”</span></p>
<p class="toc2"><span href="#/chapter05" title="Link target outside of Sample">5. 1865: “Depredations of Guerrillas, Bushwhackers and Similar Assassins”</span></p>
<p class="toc2"><span href="#/chapter06" title="Link target outside of Sample">6. Postwar: “Take Your Damn Family…and Never Come Back Here Again”</span></p>
<p class="toc2"><span href="#/chapter07" title="Link target outside of Sample">7. Looking for Kirk’s War</span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample">Appendix: The Role of African Americans in the Border War</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/authors" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?518638f0